import styled, {css} from "styled-components"

export const ImportantInfoUl = styled.ul`
  ${({theme}) => css`
    padding-left: ${theme.spacing.oneAndHalf};
    margin: 0 0 -${theme.spacing.one};
  `}
`

export const ImportantInfoLi = styled.li`
  position: relative;
  list-style-type: none;
  margin: 5px 0 5px 0.8em;

  &:before {
    position: absolute;
    content: "";
    top: 8px;
    margin-left: -16px;
    width: 6px;
    height: 6px;
    border: 4px solid ${({theme}) => theme.colors.primary2};
    border-radius: 50%;
    line-height: 18px;
  }
  div,
  p {
    display: inline;
  }
`
